<template>
    <v-card class="settings-card" color="grey lighten-3">
        <template v-if="!loading">
            <DepartmentSettings />
            <v-divider />
            <CurrencySettings />
            <v-divider />
            <FacilityDeviceSettings />
            <v-divider />
            <FacilityTypeSettings />
            <v-divider />
            <BenefitSettings />
            <v-divider />
            <HolidayList />
            <v-divider />
            <EmployeeRoles />
        </template>
        <v-card-text v-else class="progress-loading">
            <v-progress-circular indeterminate v-bind:size="70" v-bind:width="7" color="indigo"></v-progress-circular>
        </v-card-text>
    </v-card>
</template>
<script>
    import { mapActions } from 'vuex';

    import DepartmentSettings from '@/components/pages/DepartmentSettings';
    import CurrencySettings from '@/components/pages/CurrencySettings';
    import FacilityDeviceSettings from '@/components/pages/FacilityDeviceSettings';
    import FacilityTypeSettings from '@/components/pages/FacilityTypeSettings';
    import BenefitSettings from '@/components/pages/BenefitSettings';
    import HolidayList from '@/components/pages/HolidayList';
    import EmployeeRoles from '@/components/pages/EmployeeRoles';

    export default {
        name: 'settings',
        components: {
            DepartmentSettings,
            CurrencySettings,
            FacilityDeviceSettings,
            FacilityTypeSettings,
            BenefitSettings,
            HolidayList,
            EmployeeRoles
        },
        data() {
            return {
                loading: false
            };
        },
        created() {
            this.loading = true;
            Promise.all([
                this.fetchCurrencies(),
                this.fetchDepartments(),
                this.fetchFacilityTypes(),
                this.fetchFacilityDevices(),
                this.fetchBenefits(),
                this.fetchHolidays()
            ]).then(() => {
                this.loading = false;
            });
        },
        methods: {
            ...mapActions([
                'fetchCurrencies',
                'fetchDepartments',
                'fetchFacilityTypes',
                'fetchFacilityDevices',
                'fetchBenefits',
                'fetchHolidays'
            ])
        }
    };
</script>


// WEBPACK FOOTER //
// src/components/pages/Settings.vue